import * as React from 'react';

import { AutoAuthoResult } from './auto-autho.component';

export interface AutoAuthoAuthorizationDeniedProperties {
  readonly swoId: number;
  readonly result: AutoAuthoResult;
  readonly tripStatusDescription: string;
  readonly gotoValidationPage: () => void;
}

export function AutoAuthoAuthorizationDenied(props: AutoAuthoAuthorizationDeniedProperties): JSX.Element {
  return (
    <div className="row center-xs">
      <div className="col">
        <h2>Auto-Authorization Request Refused</h2>
        <h4>SWO #: {props.swoId}</h4>
        <h4>SWO Trip Status: {props.tripStatusDescription}</h4>
        <br />
        <p>Your mobile autho request has been refused for the following reasons:</p>
        <div>
          <ul className="text-left">
            {props.result.authorizationAmountExceedsLimit && <li>The request is above your autho limit.</li>}
            {props.result.hasNonCoveredCosts && <li>The request has non-covered costs.</li>}
            {props.result.isPossibleDenial && <li>The request has possible denials.</li>}
            {props.result.needsEquipmentOrdered && (
              <li>The request requires FNHW to purchase parts and/or equipment.</li>
            )}
          </ul>
        </div>
        <br />
        <p>
          Please submit your report online at <a href="https://fnhw.com/vendor">{`https://fnhw.com/vendor`}</a> or call
          1-800-208-3151.
        </p>
        <button className="btn btn-primary" onClick={props.gotoValidationPage}>
          Home
        </button>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/auto-autho/_components/authorization-denied.component.tsx